var $ = jQuery.noConflict();
var $window = jQuery(window);

var rtime;
var timeout = false;
var delta = 200;
var parallaxrunset = 0;

jQuery(window).on('resize', function () {
	rtime = new Date();
	if (timeout === false) {
		timeout = true;
		setTimeout(resizeend, delta);
	}
});

/*
 * Add your functions triggered after resize end
 */
function resizeend() {
	if (new Date() - rtime < delta) {
		setTimeout(resizeend, delta);
	} else {
		timeout = false;

		/* Make #content padding top whene use fixed menu - engine.js */
		fixedTopForHeader();

		/* Bootstrap -  set same height for all .col* in .row-eq-height - engine.js */
		rowEQheight();

		/* Bootstrap - full width element .full_width_element when use container for all page */
		fullWidthElement();

		/* Update screen size in right bottom corner */
		screenSize();

	}
}

/*
 * Add your functions triggered after page ready
 */
jQuery(document).ready(function () {

	/* animated burger icon mobile*/
	jQuery("#main-nav-toggle-top-mobile .navbar-toggle, #main-nav-toggle-top .navbar-toggle").on("click", function () {
		jQuery(this).toggleClass("active");
		if ($('.navbar-toggle').hasClass('active')) {
			$('body').addClass('is-blocked');
			$('#header').addClass("opened");
		} else {
			$('body').removeClass('is-blocked');
			$('#header').removeClass("opened");
		}
	});

	/* Show grid lines and screen width on right bottom corner - engine.js */
	screenSize();
	showGridLines();

	/* Make #content padding top whene use fixed menu - engine.js */
	fixedTopForHeader();

	/* Bootstrap - scroll to colapsed element in acordeon - engine.js */
	scrollToColapsedElement();

	/* Bootstrap - on hover show (slide) submenu - engine.js */
	toggleNavbarMethod();

	/* Bootstrap - scroll to colapsed element in acordeon - engine.js */
	scrollToColapsedElement();

	wooCommerceRelatedCarousel();

	/* login register */
	loginRegisterSwitch();

	/* cookie banner */
	cookieBannerTrigger();

	/* shipping banner */
	shippingBannerTrigger();

	/* Mailchimp */
	addFreshmail();

	/* Search button */
	searchButtonTrigger();
});

/*
 * Add your functions triggered after scroll
 */
jQuery(window).scroll(function () {
	var scroll = $(window).scrollTop();

	if (scroll >= 1) {
		jQuery("#header").addClass("fixed");
	} else {
		jQuery("#header").removeClass("fixed");

	}
});

/*
 * Add your functions triggered after all media and page loaded
 */
jQuery(window).on('load', function () {

	/* trigger resize to recomposition element after load */
	jQuery(window).trigger('resize');

	autoplayVideo();

});

/* Global - scroll page to TOP */
function backToTop() {
	jQuery("html, body").animate({scrollTop: 0}, 1000);
}

function wooCommerceRelatedCarousel() {
	if (jQuery('.related-products-carousel-wrapper').length) {
		console.log('related-products-carousel-wrapper')
		const related = new Swiper('.related-products-carousel-wrapper', {
			// Optional parameters
			loop: true,
			slidesPerView: 'auto',
			spaceBetween: 0,
			watchOverflow: false,
			keyboard: {
				enabled: true,
				onlyInViewport: false,
			},
		});
	}
}

function loginRegisterSwitch() {
	if (jQuery('.woo-login').length) {
		jQuery('.woocommerce').find('.login-switch').each(function () {
			jQuery(this).on('click tap', function () {
				var target = jQuery(this).data('goto');
				if (target === 'woo-register') {
					jQuery('.woo-login').slideUp(function () {
						jQuery('.woo-register').slideDown();
					});
				} else {
					jQuery('.woo-register').slideUp(function () {
						jQuery('.woo-login').slideDown();
					});
				}

			});

		});
		jQuery('.woocommerce .woocommerce-notices-wrapper a').each(function(){
			jQuery(this).on('click tap', function () {
				if(jQuery('.woo-login').css('display') === 'none'){
					jQuery('.woo-register').slideUp(function () {
						jQuery('.woo-login').slideDown();
					});
				}
			});
		})
	}
}



function autoplayVideo(){

	jQuery('.product-banner__content').each(function(){
		const offsetRange = $(window).height() + 100;
		const thisVideo = jQuery(this).find('video');
		const playVideo = jQuery(this).find('.play');
		const stopVideo = jQuery(this).find('.stop');

		if(thisVideo.length){
			playVideo.data('play', 0);
			playVideo.data('customer', 0);

			// buttons
			playVideo.on('click', function(){
				playVideo.fadeOut();
				stopVideo.fadeIn();
				playVideo.data('play', 1);
				playVideo.data('customer', 1);
				thisVideo.trigger('play');
			});
			// buttons
			stopVideo.on('click', function(){
				stopVideo.fadeOut();
				playVideo.fadeIn();
				playVideo.data('play', 0);
				playVideo.data('customer', 1);
				thisVideo.trigger('pause');

			});



			// event on scroll
			jQuery(window).scroll(function(e){

				const videoTop = thisVideo.offset().top;
				const videobottom = videoTop + thisVideo.outerHeight();

				const offsetTop = $(window).scrollTop(),
						offsetBottom = offsetTop + offsetRange;

/*				console.log('ot:' + offsetTop);
				//console.log('ob:' + offsetBottom);
				console.log('vt:' + videoTop);
				console.log('vb:' + videobottom);*/


				if (offsetBottom > videoTop && videobottom > offsetTop) {
					if(playVideo.data('play') === 0  && playVideo.data('customer') === 0){
						playVideo.data('play', 1);
						thisVideo.trigger('play');
						//thisVideo.play();
						console.log('play');
					}
				} else {
					if(playVideo.data('play') === 1 && playVideo.data('customer') === 0){
						playVideo.data('play', 0);
						thisVideo.trigger('pause');
						//thisVideo.pause();
						console.log('stop');
					}
				}
			});
		}


	});
}

function cookieBannerTrigger(){
	// if no cookie
	if(jQuery( ".bottom-ribbon" ).length){
		if (!getCookie('cookieConsent')) {
			jQuery( ".bottom-ribbon" ).show();
			jQuery(".close-bottom-ribbon").on('click tap', function() {
				jQuery( ".bottom-ribbon" ).slideUp( "slow" );
				// set the cookie for 30 days
				setCookie('cookieConsent', true, 30);
			});
		}
	}
}

function shippingBannerTrigger(){
	// if no cookie
	if(jQuery( ".top-ribbon" ).length){
		if (!getCookie('cookieShipping')) {
			jQuery( ".top-ribbon" ).show();
			if(!jQuery( ".home" ).length) {
				jQuery( 'main').css('margin-top', '4.7rem');
				//jQuery( 'header').css('margin-top', '-4.7rem');
			}
			jQuery(".close-top-ribbon").on('click tap', function() {
				jQuery( ".top-ribbon" ).slideUp( "slow" );
				jQuery( 'main').css('margin-top', 0);
				//jQuery( 'header').css('margin-top', 0);
				// set the cookie for 30 days
				setCookie('cookieShipping', true, 1);
			});
		}
	}
}
